import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useDispositionCache } from './cache'
import {
  type DispositionData,
  type DispositionUpdateInput,
  type DispositionUpdateSuccess,
  isDeleted,
  toResponseError,
} from '@terros/common'

export function useUpdateDisposition(): UpdateHookResponse<DispositionData, DispositionData> {
  const mutation = useTantalimMutation<DispositionUpdateInput, DispositionUpdateSuccess>({
    url: '/disposition/update',
  })
  const cache = useDispositionCache()
  async function update(previous: DispositionData): Promise<DispositionData> {
    try {
      const { disposition: saved } = await mutation.mutateAsync({ disposition: previous })
      if (isDeleted(saved)) {
        cache.removeItem(saved.dispositionId)
      } else {
        cache.replaceItem(saved)
      }
      return saved
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
